'use client';

import { useContentSize } from '@/components/SizeProvider';
import { useIsSafari } from '@/lib/hooks/useIsSafari';
import ButtonRight from './ButtonRight';
import { MAIL_CONFIG } from '@/lib/config';

const ContactInfo = () => {
  const { width: widthContent, height: heightContent } = useContentSize();
  const size = heightContent / 9 + widthContent / 16;
  const isSafari = useIsSafari();

  const _goList = () => {
    window.location.href = `mailto:${MAIL_CONFIG}`;
  };

  return (
    <div className={'content-right-box'} style={{ fontWeight: isSafari ? 500 : 700 }}>
      <div className='contact-content'>
        <h2 className='text-gray letter-scrambler'>{'\\\\SOCIALS\\\\'}</h2>
        <a href="https://www.instagram.com/theotherlab.co/" target="_blank" rel="noopener noreferrer" className='letter-scrambler social-item'>INSTAGRAM</a>
        {/* <a href="#" target="_blank" rel="noopener noreferrer" className='letter-scrambler social-item'>BLOG</a> */}
        <p className={isSafari ? "text-gray-safari2" : 'text-gray'}>{"<>"}</p>
        <h2 className='text-gray letter-scrambler'>{'\\\\REACH\\\\'}</h2>
        <div>
          <p className='letter-scrambler'>195 PEARL'S HILL TERRACE</p>
          <p className='letter-scrambler'>#03-76 SINGAPORE 168976</p>
        </div>
        <p className='text-gray final-or letter-scrambler'>{'< OR >'}</p>
      </div>
      <ButtonRight goList={_goList} size={size} style={{ height: heightContent / 22 }} />
    </div>
  )
};

export default ContactInfo